import React from "react";
import { useParams } from "react-router-dom";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import BuilderTabs from "../../Layouts/BuilderTabs";
import ApplicationHealth from "./ApplicationHealth";
import DomainManager from "./DomainManager";

const ClusterManagerSection = () => {
  const params = useParams();

  return (
    <div className="application_container">
      <AppLeftSideBar type={params.orgId ? "app" : "org"} />
      <ClusterManagerCenterViewer />
    </div>
  );
};

const ClusterManagerCenterViewer = () => {
  return (
    <div className="dashboard_outer_section">
      <div className="org-dashboard-page-body py_3 overflow_hidden ">
        <BuilderTabs
          containerClass="themes_tabs pt_4"
          contentClass="h_100 w_100 overflow_auto pb_5"
          tabs={[
            {
              label: "App Health",
              content: <ApplicationHealth />
            },
            {
              label: "Domains",
              content: <DomainManager />
            }
          ]}
        />
      </div>
    </div>
  );
};

export default ClusterManagerSection;
